import { BCDataGrid, BCTreeList } from '@bimser/components';
import { createGuid } from '@bimser/core';
import DataGrid2 from '../..';
import { IUserEvent } from '../../../../../../entities/services';
import { IControlExecutedServerEvent, IRowRemovingEventArgs } from '../../../../entities/EventArgs';

export async function onRowRemoving(
	this: DataGrid2,
	e:
		| BCDataGrid.Entities.DataGridTypes.RowRemovingEvent
		| BCTreeList.Components.TreeListTypes.RowRemovingEvent
) {
	e.cancel = new Promise<boolean>(async res => {
		const args: IRowRemovingEventArgs = {
			cancel: false,
			row: e.data,
			rows: this.rows.map(row => row.data)
		};

		await this.emit('event:OnRowRemoving', args);

		const executedServerEventArgs = await this.emit<IUserEvent<IRowRemovingEventArgs>>(
			'event:server:OnRowRemoving',
			{
				argument: args,
				controlId: this.name,
				name: 'OnRowRemoving',
				sender: 'web',
				guid: createGuid()
			}
		);

		const serverCancel = (
			executedServerEventArgs[0]?.executedServerEvent as IControlExecutedServerEvent
		)?.parameters.cancel;

		if (typeof serverCancel === 'boolean') {
			args.cancel = serverCancel;
		}

		res(args.cancel);
	});
}
